// datatable related plugins
import CustomDateFilter from "components/shared-components/RemoteTable/custom-date-filter";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import {
  AUTH_STATUS_APPROVE,
  AUTH_STATUS_NEW,
  AUTH_STATUS_PROGRESSING,
  AUTH_STATUS_REJECT,
  AUTH_STATUS_RR,
  AUTH_STATUS_RRE,
  REGISTRY_INVOICE_FIELD,
} from "constants/FormatDataContanst";
import { CUSTOM_DATE_FILTER_TABLE_TYPE } from "constants/RemoteDataTableContanst";
import { tableFormateDate } from "pages/DataFormatInvoice/utils";
import { IS_POS_LABEL } from "pages/Error-invoice/utils";
import {
  FILE_NAME_REPORT,
  PATH_TYPE_REPORT,
  TYPE_REPORT,
} from "pages/ReportInvoiceError/helper/functionHelper";
import DetailReport from "pages/ReportZipFile/DetailReport";
import { getTimeContent } from "pages/ReportZipFile/helper/functionHelper";
import React, { useEffect, useState } from "react";
import {
  customFilter,
  selectFilter,
  textFilter,
} from "react-bootstrap-table2-filter";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { Badge, Button, Card, CardBody, Col, Row } from "reactstrap";
import {
  downloadReportInvoice,
  getReportInvoiceList,
  resetReportInvoiceList,
  setColumnVisibleReportInvoiceList,
} from "store/summary-invoice-data/actions";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { getReportStatus } from "./helper/functionHelper";
const ListData = props => {
  // modalErrorRelease
  const [idRelease, setIdRelease] = useState(null);
  const [modalErrorRelease, setModalErrorRelease] = useState(false);
  const toggleErrorReleaseModal = () =>
    setModalErrorRelease(!modalErrorRelease);

  const [modalDetail, setModalDetail] = useState(false);
  const [dataDetail, setDataDetail] = useState(null);
  const toggleViewDetailModal = () => setModalDetail(!modalDetail);

  const { addToast } = useToasts();

  const [columns, setColumns] = useState([]);

  const dispatch = useDispatch();
  // store reducer
  const summaryInvoiceData = useSelector(state => state.summaryInvoiceData);
  const { type, fileDownload, fileDownloadName } = summaryInvoiceData;
  const { loading, listData, totalCount, columnsVisible, params } =
    summaryInvoiceData.reportInvoiceList;
  const history = useHistory();

  const { t, i18n } = useTranslation(["summaryInvoiceData"]);

  const [commonStatus, setCommonStatus] = useState(getReportStatus(t));

  useEffect(() => {
    setCommonStatus(getReportStatus(t));
  }, [t]);

  useEffect(() => {
    initColumn();
  }, [commonStatus]);

  //   useEffect(() => {
  //     switch (type) {
  //       case RELEASE_INVOICE_CYCLES_SUCCESS:
  //         addToast("Gửi phát hành bảng tổng hợp dữ liệu thành công", {
  //           appearance: "success",
  //           autoDismiss: true,
  //         });
  //         toggleHSMSignModal();
  //         dispatch(getReportInvoiceList(params));
  //         dispatch(resetReleaseInvoiceCycles());
  //         break;
  //       case RELEASE_INVOICE_CYCLES_FAIL:
  //         addToast("Gửi phát hành bảng tổng hợp dữ liệu thất bại", {
  //           appearance: "error",
  //           autoDismiss: true,
  //         });
  //         dispatch(resetReleaseInvoiceCycles());
  //         break;
  //     }
  //   }, [type]);

  const Dashboard = useSelector(state => state.Dashboard);
  const { tenantCodeHeader, finalBuInfo } = Dashboard;

  // Action list chang tenantCode
  useEffect(() => {
    if (finalBuInfo) {
      params.page = 1;
      dispatch(getReportInvoiceList(params, TYPE_REPORT.USE));
    }
  }, [finalBuInfo]);

  useEffect(() => {
    initColumn();
    return () => {
      dispatch(resetReportInvoiceList());
    };
  }, []);

  const initColumn = () => {
    if (Object.keys(columnsVisible).length !== 0) {
      for (const item of initColumns) {
        if (columnsVisible[item.dataField] !== undefined) {
          item.hidden = !columnsVisible[item.dataField];
        }
      }
    }
    setColumns(initColumns);
  };

  const rowEvents = {
    onDoubleClick: (e, row, rowIndex) => {
      openDetail(row);
    },
  };

  const openDetail = row => {
    setDataDetail({
      ...row,
      fileName: FILE_NAME_REPORT.USE + getTimeContent(row.parameters),
      pathType: PATH_TYPE_REPORT.EXCEL,
    });
    toggleViewDetailModal();
  };

  const listRowAction = [
    {
      icon: <i className="bx bx-download font-size-18 text-primary" />,
      text: "Download file",
      conditionVisible: {
        resource_id: [],
      },
      onClick: row => {
        dispatch(
          downloadReportInvoice(
            row.id,
            FILE_NAME_REPORT.USE + getTimeContent(row.parameters)
          )
        );
      },
    },
  ];

  const OPTION_HTHUC = [
    {
      value: REGISTRY_INVOICE_FIELD.COMMON.HTHUC.selectValues.ADD,
      label: t("select.hthuc_add"),
    },
    {
      value: REGISTRY_INVOICE_FIELD.COMMON.HTHUC.selectValues.EDIT,
      label: t("select.hthuc_edit"),
    },
  ];

  const selectFilterHTHUC = {
    [REGISTRY_INVOICE_FIELD.COMMON.HTHUC.selectValues.ADD]:
      t("select.hthuc_add"),
    [REGISTRY_INVOICE_FIELD.COMMON.HTHUC.selectValues.EDIT]:
      t("select.hthuc_edit"),
  };

  const getAuthStatus = (status, id) => {
    let infoError = null;
    if (
      status === AUTH_STATUS_REJECT ||
      status === AUTH_STATUS_RRE ||
      status === AUTH_STATUS_RR
    ) {
      infoError = (
        <i
          style={{ cursor: "pointer" }}
          title="Hiển thị lý do từ chối"
          className="font-size-17 bx bx-info-circle text-danger"
          onClick={() => {
            setIdRelease(id);
            toggleErrorReleaseModal();
          }}
        ></i>
      );
    }
    return (
      <React.Fragment>
        <div className="d-flex gap-1">
          <Badge
            className={`font-size-12 ${commonStatus?.AUTH_STATUS[status]?.badgeColor}`}
            pill
          >
            {commonStatus?.AUTH_STATUS[status]?.text}
          </Badge>
          {infoError}
        </div>
      </React.Fragment>
    );
  };

  const selectFilterAuthStatus = {
    [AUTH_STATUS_NEW]: commonStatus?.AUTH_STATUS[AUTH_STATUS_NEW]?.text, // "Lưu tạm",
    [AUTH_STATUS_PROGRESSING]:
      commonStatus?.AUTH_STATUS[AUTH_STATUS_PROGRESSING]?.text, // "Đang xử lý",
    [AUTH_STATUS_APPROVE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_APPROVE]?.text, // "Hoàn tất",
  };

  const initColumns = [
    {
      dataField: "id",
      text: "Id",
      sort: true,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
        style: { width: "75px" },
      }),
    },
    {
      dataField: "resource_id",
      text: "Tiến độ",
      headerStyle: (colum, colIndex) => {
        return { width: "80px" };
      },
      formatter: (cellContent, row) => {
        return (
          <div
            style={{ cursor: "pointer" }}
            className={"text-center text-info font-size-16"}
            onClick={() => {
              openDetail(row);
            }}
          >
            Xem
          </div>
        );
      },
    },
    {
      dataField: "parameters.type",
      text: "Mẫu hóa đơn",
      formatter: (cell, row) => {
        let textFinal = "";
        if (cell && Array.isArray(cell)) {
          const array = [];
          for (const item of cell) {
            const data = `${t(`khmhdon_list.${item}`)}`;
            array.push(data);
          }
          textFinal = array.join(", ");
        } else {
          textFinal = `${t(`khmhdon_list.${row.type}`)}`;
        }
        return (
          <div
            className="text-primary"
            style={{
              fontWeight: "bold",
              width: "400px",
              whiteSpace: "initial",
            }}
          >
            {textFinal}
          </div>
        );
      },
      //   filter: customFilter({
      //     type: CUSTOM_SELECT_FILTER_TABLE_TYPE,
      //   }),
      //   filterRenderer: (onFilter, column) => (
      //     <CustomSelectFilter
      //       onFilter={onFilter}
      //       column={column}
      //       paramFilter={params.columnFilter}
      //       dataSelect={listKHMHD}
      //       placeholder={t("placeholder.select")}
      //     />
      //   ),
    },
    {
      dataField: "is_pos",
      text: "Loại HĐ",
      sort: true,
      formatter: (cell, row) => {
        return IS_POS_LABEL[cell] || cell;
      },
      filter: selectFilter({
        placeholder: "Chọn",
        options: IS_POS_LABEL,
      }),
    },
    {
      dataField: "parameters",
      text: "Thời gian thống kê",
      hidden: false,
      formatter: (cellContent, row) => {
        return getTimeContent(cellContent);
      },
    },
    {
      dataField: "auth_status",
      text: t("auth_status.name"),
      hidden: false,
      formatter: (cellContent, row) => getAuthStatus(row.auth_status, row.id),
      filter: selectFilter({
        placeholder: t("placeholder.select"),
        options: selectFilterAuthStatus,
      }),
    },
    {
      dataField: "parameters.bu_code",
      text: "Mã chi nhánh/ đơn vị",
      headerStyle: (colum, colIndex) => {
        return { width: "200px" };
      },
      sort: true,
      formatter: (cell, row) => {
        let textFinal = "";
        if (cell && Array.isArray(cell)) {
          const array = [];
          for (const item of cell) {
            const data = item;
            array.push(data);
          }
          textFinal = array.join(", ");
        } else {
          textFinal = row.bu_code;
        }
        return (
          <div
            className="text-info text-truncate--3"
            title={textFinal}
            style={{
              fontWeight: "bold",
            }}
          >
            {textFinal}
          </div>
        );
      },
    },
    {
      dataField: "checker_date",
      text: "Ngày tạo",
      hidden: false,
      formatter: (cellContent, row) => tableFormateDate(row.checker_date),
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={params.columnFilter}
        />
      ),
    },
  ];

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, columnFilter }
  ) => {
    params.sort = sortField ? sortOrder + sortField : params.sort;
    params.columnFilter = columnFilter;
    params.page = page;
    params.sizePerPage = sizePerPage;
    dispatch(getReportInvoiceList(params, TYPE_REPORT.USE));
  };

  const onSearchAllHandle = value => {
    params.keywords = value;
    dispatch(getReportInvoiceList(params, TYPE_REPORT.USE));
  };

  const optionShowColumnHandel = (field, value) => {
    const targetColumn = columns.find(item => item.dataField === field);
    if (targetColumn) {
      targetColumn.hidden = !value;
    }
    setColumns(columns);
    dispatch(setColumnVisibleReportInvoiceList(field, value));
  };

  const resetDataFunc = () => {
    dispatch(getReportInvoiceList(params, TYPE_REPORT.USE));
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Danh sách bảng kê tình hình sử dụng</title>
        </MetaTags>
        <div className="container-fluid">
          <DetailReport
            isOpenModal={modalDetail}
            t={t}
            dataDetail={dataDetail}
            toggleModal={toggleViewDetailModal}
          />
          <Breadcrumbs
            title=""
            breadcrumbItem={
              "Danh sách bảng kê tình hình sử dụng" + ` (${totalCount})`
            }
          />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <React.Fragment>
                    <RemoteDataTable
                      keyField="id"
                      data={listData}
                      columns={columns}
                      page={params.page}
                      listRowAction={listRowAction}
                      sizePerPage={params.sizePerPage}
                      totalSize={totalCount}
                      loading={loading}
                      onTableChange={handleTableChange}
                      onSearchAllHandle={onSearchAllHandle}
                      optionShowColumnHandel={optionShowColumnHandel}
                      rowEvents={rowEvents}
                    >
                      <Button
                        type="button"
                        color="primary"
                        className="me-2 btn-label"
                        onClick={() => {
                          history.push("/report/create-report-invoice-use");
                        }}
                      >
                        <i className="bx bx-plus label-icon" />
                        Thêm mới
                      </Button>
                    </RemoteDataTable>
                  </React.Fragment>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ListData;
